import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

const LivesSection = () => {
  const videos = [
    {
      id: "jWG98KGDWwA",
      title: "Caminhando nos Trilhos",
      canal: "Trilhos e Trem"
    },
    {
      id: "FeaOY4v65yk",
      title: "Reflexão Diária",
      canal: "Palavra Viva"
    },
    {
      id: "TpCLyrRg6wk",
      title: "O que aconteceu antes da criação do mundo?",
      canal: "Canal de Oração"
    },
    {
      id: "Jd8xNb8PND8",
      title: "Momento de Fé",
      canal: "Palavra Viva",
      isShort: true
    }
  ];

  const openYoutubeVideo = (id: string, isShort = false) => {
    const url = isShort 
      ? `https://www.youtube.com/shorts/${id}` 
      : `https://www.youtube.com/watch?v=${id}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section id="lives" className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent py-2">
            Lives e Vídeos
          </h2>
          <p className="text-muted-foreground mt-2 max-w-2xl mx-auto">
            Assista nossas transmissões ao vivo e vídeos selecionados diretamente do YouTube.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {videos.map((video) => (
            <Card key={video.id} className="overflow-hidden border border-border">
              <div className="relative">
                <img 
                  src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`} 
                  alt={video.title} 
                  className="w-full h-40 object-cover cursor-pointer"
                  onClick={() => openYoutubeVideo(video.id, video.isShort)} 
                />
                <div 
                  className="absolute inset-0 flex items-center justify-center bg-black/40 hover:bg-black/60 transition-colors cursor-pointer"
                  onClick={() => openYoutubeVideo(video.id, video.isShort)}
                >
                  <Youtube size={40} className="text-red-500" />
                </div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white px-2 py-1 text-sm rounded">
                  {video.canal}
                </div>
                {video.isShort && (
                  <div className="absolute top-2 left-2 bg-red-500 text-white px-2 py-1 text-xs rounded-full">
                    Short
                  </div>
                )}
              </div>
              <CardContent className="p-3">
                <h3 className="font-medium text-sm line-clamp-1" title={video.title}>
                  {video.title}
                </h3>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground">
            <Link to="/lives">
              Ver Todas as Lives <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default LivesSection;